import React from 'react';
import styled from 'styled-components';

// Components
import { CheckBox_v2 } from 'wg-fe-ui';

interface Props {
  title: string;
  description?: string | null;
  value: boolean;
  onChange: (arg0: boolean) => void;
}

const CheckBox: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  description,
  onChange,
  value,
}) => {
  // Event is not wanting to work correctly, so skipping TS here because I am too lazy
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleCheckboxClick = (e: any) => {
    if (e.target && e.target?.tagName !== 'A') {
      e.preventDefault();
      onChange(!value);
    }
  };

  return (
    <Wrapper
      onClick={handleCheckboxClick}
      checked={value}
      data-test-id="ProdFac_Checkbox"
    >
      <StyledCheckBox checked={value} onClick={handleCheckboxClick} />
      <TitleWrapper data-test-id="ProdFac_CheckboxWithIcon_TitleWrapper">
        <Title
          checked={value}
          data-test-id="ProdFac_CheckboxWithIcon_Title"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        {description && (
          <Description
            data-test-id="ProdFac_CheckboxWithIcon_Description"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        )}
      </TitleWrapper>
    </Wrapper>
  );
};

const StyledCheckBox = styled(CheckBox_v2)<{ checked: boolean }>`
  display: block;
  margin-right: 2.4rem;
  div {
    border: 2px solid
      ${({ theme, checked }) =>
        checked ? theme.brand.primary : theme.gray[100]};
    width: 2.5rem;
    height: 2.5rem;
    margin: 0;
  }
`;

const Description = styled.p`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.typo.subTitle};
`;

const TitleWrapper = styled.div`
  width: 100%;
`;

const Title = styled.h4<{ checked: boolean }>`
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 120%;
  color: ${({ theme, checked }) =>
    checked ? theme.brand.primary : theme.typo.title};
  width: 100%;
`;

const Wrapper = styled.div<{ checked: boolean }>`
  background: #fff;
  display: flex;
  align-items: center;
  padding: 1.6rem;
  width: 100%;
  height: 100%;

  border: 1px solid
    ${({ theme, checked }) => (checked ? theme.brand.primary : theme.gray[100])};
  border-radius: 8px;
  cursor: pointer;
  transition: box-shadow 0.2s;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.1),
    0 0 1px rgba(0, 0, 0, 0.06);
`;

export default CheckBox;
